import React from 'react';

import { ActionIcon, Title } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { ReactComponent as KiloLogo } from 'assets/svg/long_kilo_blue_white.svg';
import { useLocation, useNavigate } from 'react-router-dom';

interface IBackHeader {
  title: string;
}
const BackHeader = ({ title }: IBackHeader): JSX.Element => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleBackClick = (): void => {
    if (state && state.prevPath) {
      navigate(state.prevPath, { state: state });
    } else {
      navigate(-1);
    }
  };

  return (
    <div className='header'>
      <ActionIcon variant='light' radius='lg' size='xl' onClick={handleBackClick}>
        <IconChevronLeft size='1.625rem' />
      </ActionIcon>
      <Title order={3} color='gray.8' align='center'>
        {title}
      </Title>
      <KiloLogo height='100%' width={50} />
    </div>
  );
};

export default BackHeader;
